module.exports = __webpack_public_path__ + "media/images/liv__logo--small-40227bbd722e851ea3b4b0382d1645c4.png";